import React from 'react';
import NotificationItem from './NotificationItem';
import NotificationActivityLogItem from './NotificationActivityLogItem';

const NotificationList = ({
  messages,
  activityLogs,
  view,
  lastCheckTime = 0,
  hasMore = false,
  loadingMore = false,
  onLoadMore,
}) => {
  const displayItems = view === 'logs' ? activityLogs : messages;

  return (
    <div className="notification-list">
      {displayItems.length === 0 ? (
        <div className="notification-empty">
          <p>No {view === 'logs' ? 'activity logs' : 'notifications'}</p>
        </div>
      ) : (
        <>
          {displayItems.map((item) => {
            const isNew = view === 'logs'
              ? (item.timestamp > lastCheckTime)
              : (item.createdAt > lastCheckTime);

            if (view === 'logs') {
              return (
                <NotificationActivityLogItem
                  key={item.id || item.timestamp}
                  log={item}
                  isNew={isNew}
                />
              );
            }
            return (
              <NotificationItem
                key={item.uid}
                message={item}
                isNew={isNew}
              />
            );
          })}
          {hasMore && onLoadMore && (
            <button
              className="notification-load-more"
              onClick={onLoadMore}
              disabled={loadingMore}
            >
              {loadingMore ? 'Loading...' : 'Load more'}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default NotificationList;
